import React from 'react';
import Navbar from '../../components/Navbar';
import DICOMDetail from '../../components/DICOM/DICOMDetail';
import './DICOMDetailPage.css';

const DICOMDetailPage = () => {
  return (
    <div className="dicom-detail-page">
      <Navbar />
      <div className="dicom-detail-content">
        <DICOMDetail />
      </div>
    </div>
  );
};

export default DICOMDetailPage;
